import "./style.css";
import { Feature, Map, View } from "ol";
import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector";
import OSM from "ol/source/OSM";

//import Feature from "ol/Feature";
import { Circle as CircleStyle, Fill, Icon, Stroke, Style } from "ol/style.js";

import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";

import { fromLonLat } from "ol/proj";
import { Point } from "ol/geom";

import { geoJSON } from "./geojson";

const vectorSource = new VectorSource({
  features: new GeoJSON().readFeatures(geoJSON),
});

const proviIconFeature = new Feature({
  geometry: new Point(fromLonLat([-56.26800937128883, -34.8784145555256])),
  name: "Centro Educativo Providencia",
});

const proviIconStyles = new Style({
  image: new Icon({
    src: "assets/logo-provi.svg",
    scale: .8

  }),
});

proviIconFeature.setStyle(proviIconStyles);

vectorSource.addFeature(proviIconFeature);

const styles = {
  Polygon: new Style({
    stroke: new Stroke({
      color: "rgba(255,0,0,0.5)",
      width: 2,
    }),
    fill: new Fill({
      color: "rgba(255,0,0,0.1)",
    }),
  }),
};

const styleFunction = function (feature) {
  return styles[feature.getGeometry().getType()];
};

const vectorLayer = new VectorLayer({
  source: vectorSource,
  style: styleFunction,
});

const map = new Map({
  target: "map",
  layers: [
    new TileLayer({
      source: new OSM(),
    }),
    vectorLayer,
  ],
  view: new View({
    center: fromLonLat([-56.272468620218184, -34.884913666794176]),
    zoom: 13,
  }),
});
